import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import { formatDate } from 'utils/formatDate';

export const columnsGenerator = params => [
  {
    title: '',
    dataIndex: 'id',
    align: 'center',
    render: id => <Link to={`/catalog/market-index/${id}`}>View</Link>,
  },
  {
    title: 'Featured',
    dataIndex: 'featured',
    align: 'center',
    render: value =>
      value ? <Tag color="gold">Featured</Tag> : null,
  },
  {
    title: 'Ordering',
    dataIndex: 'ordering',
    align: 'center',
  },
  {
    title: 'Symbol',
    dataIndex: 'symbol',
    render: value => <Tag color="blue">{value}</Tag>,
  },
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Exchange',
    dataIndex: 'exchange',
  },
  {
    title: 'Value',
    dataIndex: 'value',
    align: 'right',
  },
  {
    title: 'Change',
    dataIndex: 'change',
    align: 'right',
    render: (value, record) => {
      const color = value > 0 ? 'green' : value < 0 ? 'red' : 'default';
      return (
        <Tag color={color}>
          {value} ({record.change_percentage}%)
        </Tag>
      );
    },
  },
  {
    title: 'Trade Date',
    dataIndex: 'trade_date',
    render: value => formatDate(value),
  },
];
